export default __webpack_public_path__ + "static/error-afb82cda0dc7ae829d2ecd6ad0ddd380.svg";